<div class="main-content-overview flex-[1_1_100%]" id="dashboard" (window:resize)="resize()">
  <div class="flex flex-col">
    <overview-toolbar [activeProgress]="activeProgress" [storeList]="branchList"
      [staffMembersSelector]="true" (updateEmitter)="updateData()"
      [updateButton]="true"
      [updateButton]="isUpdateable"
      [filterControls]="isFilterable"
      [downloadButton]="isDownloadable"
      (downloadEmitter)="downloadPdf()"
      [preSelectedDate]='preSelectedDateRange'
      [storeSelector]="true"
      [disableStaffMembersSelector]="true"
      (changesEmitter)="storeAndDateChanged($event)" id="toolbarView">
    </overview-toolbar>
  </div>
  <div class="wrap-content">
    <div class="dsh-main-content gap-[1%] flex flex-row p-6 max-w-full" id="chartContentView">
      <mat-card class="flex flex-row flex-[1_1_100%] h-[400px] max-w-full !rounded-2xl !border-sb-border-primary !border  !shadow-md">
        <div class="w-full h-full" #spanVis>
          @if (chartView) {
            <h4 class="mat-h4 chart-title">{{('REVENUE' | translate) + (shownDate ? ' | ' + shownDate : '')}}</h4>
          }
          @if (chartView) {
            <mat-tab-group [selectedIndex]='selectGraphIndex' class="sub-tabs" (selectedTabChange)="changeGraphTabs($event)"
              [mat-stretch-tabs]="false">
              @if (byHours) {
                <mat-tab label="{{('BY_HOUR' | translate) | uppercase}}">
                  <shopbox-chart #pChart type="line" [options]="options" [width]="widthSV" [height]="heightSV" [data]="dataGraphOptions"></shopbox-chart>
                </mat-tab>
              }
              @if (byDay) {
                <mat-tab label="{{('BY_DAY' | translate) | uppercase}}">
                  <shopbox-chart #pDChart type="line" [options]="options" [width]="widthSV" [height]="heightSV" [data]="dataGraphOptions"></shopbox-chart>
                </mat-tab>
              }
              @if (byWeek) {
                <mat-tab label="{{('BY_WEEK' | translate) | uppercase}}">
                  <shopbox-chart #pWChart type="line" [options]="options" [width]="widthSV" [height]="heightSV" [data]="dataGraphOptions"></shopbox-chart>
                </mat-tab>
              }
              @if (byMonth) {
                <mat-tab label="{{('BY_MONTH' | translate) | uppercase}}">
                  <shopbox-chart #pMChart type="line" [options]="options" [width]="widthSV" [height]="heightSV" [data]="dataGraphOptions"></shopbox-chart>
                </mat-tab>
              }
            </mat-tab-group>
          }
        </div>
      </mat-card>
    </div>
    <div class="flex flex-row p-6 pt-0" id="itemSalesTable">
      <div class="table-viewer">
        @if (typeSelector === 1) {
          <shopbox-command-menu [ngClass]="{'unClickable': activeProgress}" [setSelectedIndex]="setMenuValue" (menuEmit)="menuClickHandler($event)"></shopbox-command-menu>
        }
        <div>
          <div>
            <mat-table class="rounded-2xl !border !border-sb-border-primary !shadow-md overflow-hidden p-6 !min-w-auto" #table [dataSource]="itemsDataSource" matSort (matSortChange)="sortData($event)" matSortActive="gross_sales" matSortDirection="asc">

              <!--Select column-->
              <ng-container matColumnDef="select">
                <mat-header-cell *matHeaderCellDef>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  @if (typeSelector === 2) {
                    @if (element['type'] === 'staff') {
                      <shopbox-checkbox [toggle]="isSelectedItem(element.uid, element['type'])"
                        [color]="element.backgroundColor"
                      (changed)="updateModel($event, element.uid, element['type'])" [ngClass]="{'unClickable': activeProgress}"></shopbox-checkbox>
                    }
                    @if (element['type'] === 'product') {
                      <button mat-icon-button (click)="viewStaff(element)"
                        [ngClass]="{'unClickable': activeProgress}">
                        <mat-icon>{{foundInViewStaff(element.uid) ? iconOpend : iconClosed}}</mat-icon>
                      </button>
                    }
                  }
                  @if (typeSelector === 1) {
                    <ng-container>
                      <shopbox-checkbox [toggle]="isSelectedItem(element.uid, element['type'])"
                        [color]="element.backgroundColor"
                      (changed)="updateModel($event, element.uid, element['type'])" [ngClass]="{'unClickable': activeProgress}"></shopbox-checkbox>
                    </ng-container>
                  }
                </mat-cell>
              </ng-container>

              <!--Name column-->
              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef>
                  <mat-form-field class="item-search-field" appearance="fill">
                    <input matInput
                      [formControl]="productSearch" [ngClass]="{'unClickable': activeProgress}">
                    <mat-icon matSuffix>search</mat-icon>
                  </mat-form-field>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <ng-container>
                    {{element.name}}
                  </ng-container>
                </mat-cell>
              </ng-container>

              <!--Name column-->
              <!-- <ng-container matColumnDef="variant">
              <mat-header-cell *matHeaderCellDef></mat-header-cell>
              <mat-cell *matCellDef="let element">
                <ng-container
                  *ngIf="typeSelector === 1 && element.type === 'product'">
                  <button mat-icon-button
                    (click)="viewVariances(element)"
                    matTooltip="{{foundInViewVariances(element.uid) !== -1 ? 'HIDE VARIANCES' : 'SHOW VARIANCES'}}"
                    [ngClass]="{'unClickable': activeProgress}">
                    <mat-icon>
                      {{foundInViewVariances(element.uid) !== -1 ? iconClosed : iconOpend}}
                    </mat-icon>
                  </button>
                </ng-container>
              </mat-cell>
            </ng-container> -->

            <!--Gross sales column-->
            <ng-container matColumnDef="gross_sales">
              <mat-header-cell *matHeaderCellDef>
                <div mat-sort-header="gross_sales" arrowPosition="before" [disabled]="activeProgress">
                  {{'GROSS_SALES' | translate}}
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <ng-container>
                  {{element.grossSales}}
                </ng-container>
              </mat-cell>
            </ng-container>

            <!--Items sold column-->
            <ng-container matColumnDef="items_sold">
              <mat-header-cell *matHeaderCellDef>
                <div mat-sort-header="items_sold" arrowPosition="before" [disabled]="activeProgress">
                  {{'ITEMS_SOLD' | translate}}
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <ng-container>
                  {{element.itemsSold}}
                </ng-container>
              </mat-cell>
            </ng-container>

            <!--Net column-->
            <ng-container matColumnDef="net">
              <mat-header-cell *matHeaderCellDef>
                <div mat-sort-header="net" arrowPosition="before" [disabled]="activeProgress">
                  {{'NET' | translate}}
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <ng-container>
                  {{element.net}}
                </ng-container>
              </mat-cell>
            </ng-container>

            <!--Vat column-->
            <ng-container matColumnDef="vat">
              <mat-header-cell *matHeaderCellDef>
                <div mat-sort-header="vat" arrowPosition="before" [disabled]="activeProgress">
                  {{'VAT' | translate}}
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <ng-container>
                  {{element.vat}}
                </ng-container>
              </mat-cell>
            </ng-container>

            <!--Cost column-->
            <ng-container matColumnDef="cost">
              <mat-header-cell *matHeaderCellDef>
                <div mat-sort-header="cost" arrowPosition="before" [disabled]="activeProgress">
                  {{'COST' | translate}}
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <ng-container>
                  {{element.cost}}
                </ng-container>
              </mat-cell>
            </ng-container>

            <!--Discounts column-->
            <ng-container matColumnDef="discounts">
              <mat-header-cell *matHeaderCellDef>
                <div mat-sort-header="discounts" arrowPosition="before" [disabled]="activeProgress">
                  {{'DISCOUNTS' | translate}}
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <ng-container>
                  {{element.discounts}}
                </ng-container>
              </mat-cell>
            </ng-container>

            <!--Revenue margin column-->
            <ng-container matColumnDef="revenue_margin">
              <mat-header-cell *matHeaderCellDef>
                <div mat-sort-header="revenue_margin" arrowPosition="before" [disabled]="activeProgress">
                  {{'REVENUE_MARGIN' | translate}}
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <ng-container>
                  {{element.revenueMargin}}
                </ng-container>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></mat-header-row>
            <mat-row *matRowDef="let element; columns: displayedColumns;" [id]="element.uid"
              class="{{element['type']}}"
              [ngClass]="{'expanded-open-staff': openedStaff(element) === true , 'expanded-close-staff': openedStaff(element) === false, 'expanded-open-variances': openedVariant(element) === true , 'expanded-close-variances': openedVariant(element) === false}">
            </mat-row>
          </mat-table>
        </div>
      </div>
    </div>
    <shopbox-empty [isEmpty]="isEmpty"></shopbox-empty>
  </div>
</div>
</div>
